import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import * as LanguageRepository from "services/language/languageRepository";
import {
    buildLoadPath,
    getSupportedLanguageCodes,
    isFinnishLocalizationEnabled,
    isNewLocalizationEnabled,
    NAMESPACES,
    resolveLanguageCode,
} from "services/language/localizationPaths";

const USE_NEW_LOCALIZATION = isNewLocalizationEnabled();
const LANGUAGE_CODE = resolveLanguageCode(
    LanguageRepository.getLanguage().code,
    USE_NEW_LOCALIZATION,
    isFinnishLocalizationEnabled()
);
const VERSION = process.env.BMP_VERSION ?? "dev";
const AI_AGENT_NAME = "Blue";

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: LANGUAGE_CODE,
        preload: [LANGUAGE_CODE],
        fallbackLng: "en_US",
        debug: false,
        supportedLngs: getSupportedLanguageCodes(USE_NEW_LOCALIZATION),
        ns: NAMESPACES,
        backend: {
            // The backend is given arrays, but each file is requested separately so only the first elements matter.
            loadPath: (languageCodes: string[], namespaces: string[]) =>
                buildLoadPath(languageCodes[0], namespaces[0], USE_NEW_LOCALIZATION, VERSION),
        },

        interpolation: {
            defaultVariables: { agentName: AI_AGENT_NAME },
            escapeValue: false, // not needed for react as it escapes by default
        },
        react: {
            useSuspense: false,
            transSupportBasicHtmlNodes: true,
        },
    });

export default i18n;
